import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {FormControllerService} from "../../../../../../../services/form-controller/form-controller.service";
import FormUtils from "../../../../../../utils/form-utils.component";
import {TranslatedBaseError} from "../../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "field-set-calculate-percentage",
  templateUrl: "./field-set-calculate-percentage.component.html",
  styles: [],
})
export class FieldSetCalculatePercentageComponent extends TranslatedBaseError implements OnInit {
  @Input() public guides: any[];
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  public visibleFields: any[];
  public visibleGuides: any[];

  public dataChangedEvent(event: any) {
    this.dataChanged.emit(event);
  }

  constructor(private route: ActivatedRoute,
              private formControllerService: FormControllerService,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const serviceId = params.serviceId;
      this.getSystemFields(serviceId);
      this.filterGuides();
    });
  }

  private getSystemFields(serviceId: string) {
    this.formControllerService.getFilteredFormFields(serviceId, "number", false, false, false, false, false, false, false).subscribe(
      (data) => {
        this.visibleFields = data;
      },
      (error) => this.showErrorMessageWithTitle("Unable to get service form field list!", error),
    );
  }

    public filterGuides() {
        this.visibleGuides = this.guides ? this.guides.filter((guide) => FormUtils.convertDeterminantTypeToFieldType(guide.type) === this.fieldOptions.inputType) : [];
    }
}
